import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { PrimaryNavigationItemBase } from "./components/PrimaryNavigationItemBase";

interface PrimaryNavigationLinkProps {
  active: boolean;
  to: string;
  label: string;
  icon: ReactNode;
  activeIcon: ReactNode;
}

export const PrimaryNavigationLink = (props: PrimaryNavigationLinkProps) => {
  const { active, to, label, icon, activeIcon } = props;

  return (
    <PrimaryNavigationItemBase
      as={RouterLink}
      active={active}
      to={to}
      icon={active ? activeIcon : icon}
      label={label}
      data-product-tour={`nav-${label.toLowerCase()}`}
    />
  );
};
